export default {
  "nav.home": "Accueil",
  "nav.guide": "Guide complet",
  "nav.shopGuide": "Guide d'achat",
  "nav.categories": "Catégories",
  "nav.faq": "FAQ",
  "nav.language": "Langue",

  "announce": "Ressource indépendante • Mise à jour régulièrement • Vérifiez toujours les liens avant de commander",

  "hero.badge": "Centre de ressources USFans Spreadsheet",
  "hero.title": "USFans Spreadsheet — votre guide complet des liens, de la livraison et des achats",
  "hero.subtitle": "Trouvez des liens utiles, des avis honnêtes, des informations sur la livraison, l'entrepôt et le contrôle qualité, ainsi que des conseils sur les coupons et codes promo, le tout dans un espace clair et facile à parcourir.",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Acheter maintenant",
  "hero.trust": "Source indépendante • Fraîchement mise à jour • Utilisation sûre des liens",

  "dropdown.label": "Parcourir les catégories",
  "dropdown.placeholder": "Sélectionnez une catégorie…",

  "categories.title": "Acheter par catégorie",
  "categories.subtitle": "Accédez directement aux produits que vous recherchez sur USFans.",

  "about.title": "Qu'est-ce que le USFans Spreadsheet ?",
  "about.p1": "Le USFans Spreadsheet est une collection claire et organisée de liens produits et de raccourcis par catégorie qui vous aide à trouver plus vite ce que vous cherchez. Au lieu de parcourir des pages interminables, la feuille regroupe les articles en catégories familières — chaussures, hoodies, t-shirts, vestes et plus — pour que vous puissiez aller directement à la section qui vous intéresse.",
  "about.p2": "Notre objectif est simple : réunir les informations et les liens les plus utiles dans un format transparent et facile à consulter. Nous couvrons les avis, les frais de livraison, les détails de l'entrepôt, le contrôle qualité, les coupons et les conseils de sécurité, pour que vous puissiez décider avec plus de confiance avant de passer commande.",

  "features.title": "Tout sur USFans au même endroit",
  "features.subtitle": "Six sujets essentiels pour comprendre le service avant d'acheter.",
  "feat.review.title": "Avis USFans",
  "feat.review.desc": "Découvrez les points clés, les avantages, les inconvénients et les détails à vérifier avant d'utiliser le service.",
  "feat.shipping.title": "Frais de livraison USFans",
  "feat.shipping.desc": "Comprenez quels facteurs influencent le prix de la livraison et comment comparer les options disponibles.",
  "feat.warehouse.title": "Entrepôt USFans",
  "feat.warehouse.desc": "Apprenez les bases du stockage, de la manutention et du contrôle des commandes dans l'entrepôt.",
  "feat.legit.title": "USFans est-il fiable ?",
  "feat.legit.desc": "Découvrez comment évaluer par vous-même la fiabilité du site, des liens et des vendeurs.",
  "feat.coupon.title": "Coupon USFans",
  "feat.coupon.desc": "Apprenez à trouver des promotions et à vérifier qu'un code promo est toujours valable.",
  "feat.discount.title": "Code promo USFans",
  "feat.discount.desc": "Apprenez à vérifier l'expiration et les conditions d'un code avant de l'appliquer au paiement.",

  "why.title": "Pourquoi utiliser notre guide ?",
  "why.subtitle": "Un point de départ clair et structuré pour toute personne qui débute avec USFans.",
  "why.1": "Informations organisées",
  "why.2": "Guides pratiques",
  "why.3": "Comparaisons honnêtes",
  "why.4": "Détails du contrôle qualité (QC)",
  "why.5": "Explications sur la livraison",
  "why.6": "Recommandations de sécurité",
  "why.7": "Mises à jour régulières",
  "why.8": "Navigation facile",

  "articleCta.title": "Nouveau sur USFans ? Commencez par notre guide complet",
  "articleCta.subtitle": "Un parcours pas à pas couvrant les catégories, la livraison, le contrôle qualité, les coupons et la sécurité, pensé pour les débutants.",
  "articleCta.button": "Lire le guide complet",

  "safety.title": "La sécurité avant tout",
  "safety.text": "Vérifiez toujours l'adresse du site, les liens, le vendeur, les prix, les moyens de paiement et les informations de livraison avant de prendre une décision. Ce site est une ressource d'information indépendante et ne garantit pas la disponibilité, la sécurité ni l'exactitude des services tiers.",
  "safety.cta": "Visiter le Centre de sécurité",

  "faq.title": "Questions fréquentes",
  "faq.1q": "Qu'est-ce que le USFans Spreadsheet ?",
  "faq.1a": "C'est une collection organisée de liens produits USFans regroupés en catégories comme les chaussures, hoodies, t-shirts, vestes et accessoires, conçue pour vous aider à trouver des produits plus vite.",
  "faq.2q": "USFans est-il fiable ?",
  "faq.2a": "USFans est un service largement commenté, mais nous recommandons toujours de vérifier vous-même les liens, vendeurs, prix et moyens de paiement avant de commander. Aucun service tiers ne peut être garanti sûr sans vos propres vérifications.",
  "faq.3q": "Combien coûte la livraison USFans ?",
  "faq.3a": "Les frais de livraison dépendent de plusieurs facteurs, notamment le pays de destination, le poids du colis, le mode de livraison et d'éventuels frais d'entrepôt. Le mieux est de comparer les options disponibles au paiement.",
  "faq.4q": "Où trouver des coupons ou codes promo USFans ?",
  "faq.4a": "Les promotions changent souvent. Nous recommandons de consulter directement le site officiel et de vérifier la date d'expiration et les conditions d'un code avant de l'utiliser.",
  "faq.5q": "Comment utiliser le USFans Spreadsheet ?",
  "faq.5a": "Choisissez simplement une catégorie dans le menu déroulant ou les boutons ci-dessus, et vous serez redirigé directement vers la page USFans correspondant à ce type de produit.",

  "ctaBanner.title": "Prêt à trouver ce qu'il vous faut sur USFans ?",
  "ctaBanner.subtitle": "Ouvrez la feuille et parcourez une collection claire et organisée de liens, de guides et de comparaisons.",
  "ctaBanner.button": "Ouvrir USFans Spreadsheet",

  "footer.tagline": "Une ressource d'information indépendante sur le USFans Spreadsheet.",
  "footer.disclaimer": "Ce site est une ressource d'information indépendante et n'est ni affilié à USFans ni approuvé par lui. Vérifiez toujours par vous-même les URL, les vendeurs, les prix et les services tiers avant d'agir.",
  "footer.nav": "Navigation",
  "footer.resources": "Ressources",
  "footer.languages": "Langues",
  "footer.rights": "Tous droits réservés.",
  "footer.backHome": "Retour à l'accueil",
};